<template>
  <div id="mytable">
    <div v-if="locations.length > 0" class="locations-table-label">
      LOCATIONS
    </div>
    <div v-else class="locations-table-label" style="text-align: center;">
      Added locations will appear here.<br />Click on the map to add new
      location.
    </div>
    <b-table
      :data="locations"
      selectable
      :columns="columns"
      hoverable
      :selected.sync="selectedLocation"
      :mobile-cards="false"
    >
      <template slot-scope="props">
        <b-table-column>
          <div class>
            <article class="media location-table-item">
              <div class="media-left">
                <figure class="image is-32x32">
                  <div
                    class="avatar-img-wrap media-left"
                    v-if="props.row.name.startsWith('@')"
                  >
                    <img
                      class="table-avatar-img centered-subitem"
                      v-if="userToImage[props.row.name.substring(1)]"
                      v-bind:src="userToImage[props.row.name.substring(1)]"
                    />
                    <img
                      class="table-avatar-img centered-subitem"
                      v-else
                      src="../../public/user_72.png"
                    />
                  </div>
                  <div v-else>
                    <img
                      class="table-avatar-img centered-subitem"
                      src="../../public/star_72.png"
                    />
                  </div>
                </figure>
              </div>
              <div class="media-content">
                <div class="centered-subitem">
                  <div
                    class="row-name"
                    v-bind:id="props.row.name.replace('@', 'ATSIGN')"
                  >
                    {{ props.row.name }}
                  </div>
                  <div class="row-tags">
                    <span v-for="tag in props.row.tags">
                      {{ tag }}
                    </span>
                  </div>
                </div>
              </div>
              <span class="media-right">
                <b-dropdown
                  aria-role="list"
                  class="end item-three-dots centered-three-dots"
                  position="is-bottom-left"
                >
                  <p
                    class="tag three-dots"
                    slot="trigger"
                    role="button"
                    aria-label="More options"
                  >
                    <span class="icon">
                      <i class="fas fa-ellipsis-h"></i>
                    </span>
                  </p>

                  <b-dropdown-item
                    id="edit-tags-button"
                    aria-role="listitem"
                    @click="editTagsClicked(props.row)"
                    aria-label="Edit tags"
                  >
                    <span class="is-vertical-center">
                      <b-icon icon="tags"></b-icon>Edit tags
                    </span>
                  </b-dropdown-item>

                  <b-dropdown-item
                    id="delete-button"
                    aria-role="listitem"
                    @click="deleteLocationClicked(props.row)"
                    aria-label="Delete location"
                  >
                    <span class="is-vertical-center">
                      <b-icon icon="trash"></b-icon>Delete
                    </span>
                  </b-dropdown-item>
                </b-dropdown>
              </span>
            </article>
          </div>
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>

<script>
// TODO: Add an empty element when there are no locations
import { mapState } from "vuex";
import { Dialog } from "buefy/dist/components/dialog";
import { Toast } from "buefy/dist/components/toast";
import { deleteLocation, setLocationTags } from "../api-requests";

export default {
  name: "LocationsTable",
  data() {
    const data = this.$store.state.locations;
    const userToImage = this.$store.getters.userToImage;

    return {
      data,
      userToImage,
      columns: [
        {
          field: "name"
          // label: "Locations"
        }
      ]
    };
  },
  computed: {
    selectedLocation: {
      get: function() {
        return this.$store.getters.selectedLocation;
      },
      set: function(newValue) {
        console.log("New selected location", newValue);
        this.$store.commit("SET_SELECTED_LOCATION_ID", newValue.id);
      }
    },
    locations: {
      get: function() {
        const copied = [...this.$store.getters.selectedFloor.locations];
        return copied.sort(function(a, b) {
          // ignore upper and lowercase
          var nameA = a.name.toUpperCase();
          var nameB = b.name.toUpperCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
      }
    }
  },
  watch: {
    selectedLocation: function(newSelectedLocation, oldSelectedLocation) {
      console.log("new selected location");
    }
  },
  methods: {
    deleteLocationClicked: function(location) {
      console.log(location);
      Dialog.confirm({
        message:
          "Are you sure you want to <b>delete</b> " +
          location.name +
          "? This action cannot be undone.",
        type: "is-danger",
        hasIcon: true,
        icon: "exclamation-circle",
        iconPack: "fa",
        onConfirm: function(value) {
          console.log("Deleted the location!", location);
          deleteLocation(location.id);
        },
        confirmText: "Delete"
      });
    },
    editTagsClicked: async function(location) {
      Dialog.prompt({
        message:
          "Tags can be used to get a map with multiple locations marked on it:<br/>e.g. <mark>/map #legals</mark> can be used to get a map of all employees in the legals department.<br/><br/>Each tag should start with a hash sign (#).<br/>Please separate tags with spaces.",
        inputAttrs: {
          placeholder: "#example_one #example_two",
          maxlength: 1000,
          value: (location.tags || []).join(" ")
        },
        onConfirm: async function(value) {
          const tags = value.split(" ");
          for (let tag of tags) {
            if (tag[0] !== "#") {
              Toast.open({
                duration: 3000,
                message: `Error: Each tag must start with a hash sign (#).`,
                position: "is-bottom",
                type: "is-danger"
              });
              return;
            }
            if (tag.match(/^#.*#.*$/)) {
              Toast.open({
                duration: 3000,
                message: `Error: Tags should be separated with spaces.`,
                position: "is-bottom",
                type: "is-danger"
              });
              return;
            }
            if (!tag.match(/^#[0-9a-zA-Z_]+$/)) {
              Toast.open({
                duration: 3000,
                message: `Error: Only letters, numbers, and underscores are allowed in tag names.`,
                position: "is-bottom",
                type: "is-danger"
              });
              return;
            }
          }
          try {
            await setLocationTags(location.id, tags);
          } catch (error) {
            Toast.open({
              duration: 3000,
              message: `Error: Failed to save tags.`,
              position: "is-bottom",
              type: "is-danger"
            });
            return;
          }
          Toast.open({
            duration: 1000,
            message: "Tags saved!",
            position: "is-bottom",
            type: "is-success"
          });
        },
        confirmText: "Save"
      });
    }
  }
};
</script>

<style scoped>
#mytable {
  /* height: 65vh; */
  /* overflow-y: auto; */
}

#input {
  padding-bottom: 10px;
}

.three-dots {
  height: 10px;
  width: 22px;
}

#delete-button {
  color: #363636;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
}

::-webkit-scrollbar:vertical {
  width: 12px;
}

::-webkit-scrollbar:horizontal {
  height: 12px;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  border: 2px solid #ffffff;
}

::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #ffffff;
}

.is-vertical-center {
  display: flex;
  align-items: center;
}
</style>

<style>
.table-wrapper {
  overflow-x: initial !important;
}

.table tr td span div span div div p {
  color: white;
}
.table tr.is-selected td span div span div div p {
  color: #363636;
}
.table tr.is-selected td span div span div div p {
  color: #e8eaed;
}
.table tr td:hover span div span div div p {
  color: #363636;
}
.locations-table-label {
  color: #8e8e8e;
  font-weight: 600;
  font-size: 0.8rem;
  text-align: left;
  padding-left: 15px;
  padding-top: 18px;
}

.avatar-img-wrap {
  margin-right: 5px;
  height: 32px;
  width: 32px;
}

.table-avatar-img {
  border-radius: 10%;
  height: 32px;
  width: 32px;
  margin-right: 5px;
}

.avatar-icon {
  font-weight: 400;
  height: 32px;
  width: 32px;
}

.locations-table-row {
  height: 32px;
}

.row-name {
  font-weight: 500;
  color: #363636;
}

.row-tags {
  font-size: 12px;
  color: #727171;
  max-width: 230px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.location-table-item {
  position: relative;
}
.location-table-item:hover {
  color: #363636;
}

.centered-subitem {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.centered-three-dots {
  top: 4px;
}
</style>
